export default {
  titleContent: {
    type: String,
    default: 'incluido'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/components/resources/props.js